import { render, staticRenderFns } from "./UcCompanyMiniCard.yaml?vue&type=template&id=58cc1db3&component"
import script from "./UcCompanyMiniCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcCompanyMiniCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports